import { Fragment, useState } from "react";
import { Menu, Transition } from "@headlessui/react";
import "./style.css";
import { IoChevronBackOutline } from "react-icons/io5";

function classNames(...classes) {
  return classes.filter(Boolean).join(" ");
}

export default function Wallets() {
  const [isOpenNft0, setIsOpenNft0] = useState(false);
  const [isOpenNft1, setIsOpenNft1] = useState(false);
  const [isOpenNft2, setIsOpenNft2] = useState(false);

  const [isOpen, setIsOpen] = useState(false);

  return (
    <div className="bg-neutral-900">
      <div class="page-bg animation-wrapper">
        <div class="particle particle-1"></div>
      </div>
      <div className="mx-auto py-12 px-4 max-w-7xl sm:px-6 lg:px-8 lg:py-24">
        <div className="space-y-6">
          <h1 class="text-white mt-2 block uppercase text-3xl leading-8 font-extrabold tracking-tight sm:text-4xl">
            Tipos de Carteras Electrónicas
          </h1>
          <h3 class="block text-xl text-violet-600 font-semibold tracking-wide ">
            Más información sobre billeteras electrónicas y cómo mantener la
            seguridad de éstas.
          </h3>

          <a href="/learn" className="font-bold ml-2 text-left flex text-white">
            <IoChevronBackOutline className="mr-2 mt-1" /> volver 
            </a>

          <ul role="list" class="space-y-3 text-left">
            <li className="bg-white shadow overflow-hidden rounded-md px-6 py-4">
              <span
                onClick={() => setIsOpenNft1(!isOpenNft1)}
                className="p-4 h-14 flex justify-between cursor-pointer"
              >
                <h2 className="font-bold text-gray-900">
                  Cartera Caliente (Hot Wallet)
                </h2>
                <svg
                  className={`${
                    isOpenNft1
                      ? "rotate-180 h-6 w-6 transform text-gray-400"
                      : "rotate-360 h-6 w-6 transform text-gray-400"
                  }`}
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                  aria-hidden="true"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    d="M19 9l-7 7-7-7"
                  />
                </svg>
              </span>
              <Transition
                show={isOpenNft1}
                enter="transition-opacity duration-75"
                enterFrom="opacity-0"
                enterTo="opacity-100"
                leave="transition-opacity duration-150"
                leaveFrom="opacity-100"
                leaveTo="opacity-0"
              >
                <div className="px-6 pt-6 py-y border-t">
                  <div className="grid gap-6 grid-cols-1 md:grid-cols-1">
                    <p>
                      Una cartera caliente es una cartera digital de
                      criptomonedas donde se almacena sólo digitalmente.
                    </p>
                    <p>
                      Protegidos solo por su frase semilla, a menudo están
                      sujetos a ataques de estafadores. Si almacenas todas tus
                      criptomonedas y NFTs en tu cartera caliente, están menos
                      protegidos que cuando están en una billetera fría/cartera
                      de hardware.
                    </p>
                    <p>
                      Ejemplos de una cartera caliente son una cartera de
                      MetaMask o una cartera de Coinbase que se mantiene solo
                      digitalmente.
                    </p>
                    <br />
                  </div>
                </div>
              </Transition>
            </li>

            <li className="bg-white shadow overflow-hidden rounded-md px-6 py-4">
              <span
                onClick={() => setIsOpenNft2(!isOpenNft2)}
                className="p-4 h-14 flex justify-between cursor-pointer"
              >
                <h2 className="font-bold text-gray-900">
                  Carteras Frías (Cold Wallets)
                </h2>
                <svg
                  className={`${
                    isOpenNft2
                      ? "rotate-180 h-6 w-6 transform text-gray-400"
                      : "rotate-360 h-6 w-6 transform text-gray-400"
                  }`}
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                  aria-hidden="true"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    d="M19 9l-7 7-7-7"
                  />
                </svg>
              </span>
              <Transition
                show={isOpenNft2}
                enter="transition-opacity duration-75"
                enterFrom="opacity-0"
                enterTo="opacity-100"
                leave="transition-opacity duration-150"
                leaveFrom="opacity-100"
                leaveTo="opacity-0"
              >
                <div className="px-6 mt-4 pt-6 py-y border-t">
                  <div className="grid gap-6 grid-cols-1 md:grid-cols-1">
                    <p>
                    <strong>Carteras de Hardware (Hardware
                  Wallets)</strong>
                    </p>
                    <p>
                      Entonces, sí estás investigando cómo almacenar tus
                      criptomonedas y te has encontrado con este nuevo concepto
                      de carteras de hardware y te preguntas: "¿POR QUÉ
                      necesitaría una cartera física para almacenar mis monedas
                      y activos digitales?"
                    </p>
                    <p>¡Gran pregunta! Analizemos.</p>
                    <p>
                      Las carteras de hardware, también conocidas como carteras
                      frías, son la mejor práctica, el estándar de la industria
                      para almacenar tus activos digitales.
                    </p>
                    <p>
                      <strong>
                        Las carteras de hardware son la opción más segura por
                        varias razones:
                      </strong>
                    </p>
                    <ul className="list-decimal">
                      <li>
                        <u>Están completamente fuera de línea.</u>
                      </li>
                      <p>
                        Su clave privada se almacena de forma segura y
                        encriptada dentro de la billetera de hardware, y nunca
                        se pasa al lado online. Estar desconectado de Internet
                        hace que sea mucho más difícil para los estafadores y
                        piratas informáticos entrar y robar tus cosas.
                      </p>
                      <br />
                      <li>
                        <u>Los fondos son menos accesibles.</u>
                      </li>
                      <p>
                        Aprobar el movimiento de criptomonedas y NFT dentro o
                        fuera de su cartera de hardware requiere que realmente
                        tenga la cartera de hardware. Además de simplemente
                        necesitar estar en posesión física de la cartera,
                        también deberás ingresar un número PIN para aprobar.
                      </p>
                      <p>
                        Agrega la mayor protección de los chips encriptados para
                        combatir los intentos de piratería sofisticados, y está
                        claro por qué este es el estándar de seguridad de la
                        industria.
                      </p>
                      <br />
                      <li>
                        Las carteras de hardware son una cartera sin custodia,
                        que es una forma elegante de decir que el propietario,
                        TU, tiene el control total de lo que hay dentro de la
                        cartera.
                      </li>
                      Los activos se almacenan en la cadena de bloques, solo tú
                      los administras, por lo que no hay intermediarios como un
                      banco o una bolsa involucrada, y solo tú tienes la clave.
                    </ul>
                    <p>
                      Hay bastantes opciones de cartera de hardware en el
                      mercado, así que asegúrate de investigar y decidir la
                      opción con la que te sientas más cómodo. Las dos opciones
                      más populares a partir de este escrito son Ledger y
                      Trezor.
                    </p>
                    <p>
                      <strong>Nota de seguridad importante:</strong> al
                      seleccionar una billetera de hardware, SÓLO compra
                      directamente a través de la compañía de cartera de
                      hardware, a diferencia de un sitio de terceros como
                      Amazon. Comprar a través de un tercero aumenta la
                      posibilidad de que alguien manipule el dispositivo antes
                      de que llegue a ti, lo que permite que la billetera se vea
                      comprometida.
                    </p>
                    <br />
                  </div>
                </div>
              </Transition>
            </li>
          </ul>
        </div>
      </div>
    </div>
  );
}
